var Invoker = (function () {
    function Invoker() {
        this.receivers = [];
    }
    Invoker.prototype.invoke = function (command) {
        this.receivers.forEach(function (c) {
            if (c.hasCommand(command)) {
                c.execute(command);
            }
        });
    };
    Invoker.prototype.register = function (receiver) {
        this.receivers.push(receiver);
    };
    return Invoker;
}());
export { Invoker };
